import type { ReactNode } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

interface SiteLayoutProps {
  children: ReactNode;
  /** 页面顶部是否需要为固定导航预留空间（首页 Hero 不需要） */
  withHeaderOffset?: boolean;
}

export default function SiteLayout({ children, withHeaderOffset = true }: SiteLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col overflow-x-hidden bg-background-50">
      <Navbar />
      <main className={`flex-1 ${withHeaderOffset ? 'pt-16 md:pt-20' : ''}`}>{children}</main>
      <Footer />
    </div>
  );
}